import React, { ReactElement } from 'react';

import { Project } from '../../shared/schema/ProjectSchema';
import { isAddressCoordinates } from '../../shared/stringUtils';
import { uploadedImageDir } from '../../utils/configs';
import TrackableLink from '../TrackableLink';

const ProjectViewGridItem = (project: Project): ReactElement => {
  const { name, zip, city, address, url, images } = project;
  const zipCity = `${zip} ${city}`;

  let imgSrc = `/home/us-placeholder-square.png`;
  if (images && images.length > 0) {
    imgSrc = `${uploadedImageDir}/${images[0].path}`;
  }
  return (
    <article className="p-grid-item">
      <div className="p-grid-item-h">
        <div className="grid-padding" />
        <TrackableLink className="p-grid-link" to={`/portfolio/${url}`} />
        <div className="p-grid-image-wrapper">
          <img
            className="p-grid-image"
            src={imgSrc}
            alt={imgSrc.split('/').pop()}
          />
        </div>
        <div className="p-grid-item-info">
          <h2 className="p-grid-item-header">{name}</h2>
          <span className="p-grid-item-description">
            {!isAddressCoordinates(address) && `${address} | `}
            {zipCity}
          </span>
        </div>
      </div>
    </article>
  );
};

export default ProjectViewGridItem;
